"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconExport = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M53.27 21.38H42v5.38h8.59v31.15H19.42V26.76H28v-5.38H16.73A2.69 2.69 0 0 0 14 24.07V60.6a2.69 2.69 0 0 0 2.69 2.69h36.58A2.69 2.69 0 0 0 56 60.6V24.07a2.69 2.69 0 0 0-2.73-2.69z"
  }), _react["default"].createElement("path", {
    d: "M32.31 36.36a2.69 2.69 0 1 0 5.38 0V9.15l4.3 4.3 1.66 1.66a2.69 2.69 0 0 0 3.8-3.8L41.8 5.66 36.9.75a2.46 2.46 0 0 0-.43-.34 2.82 2.82 0 0 0-2.93 0 2.46 2.46 0 0 0-.43.34l-4.9 4.9-5.65 5.65a2.69 2.69 0 1 0 3.8 3.8L28 13.45l4.3-4.3z"
  })),
  height: undefined,
  width: undefined
});
IconExport.displayName = 'IconExport';
var _default = IconExport;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/export.js
// module id = 333
// module chunks = 0